import { Dropdown, Space } from 'antd';
import React, { FC } from 'react';
import styled from 'styled-components';
import { Button } from 'components/atoms/button';
import { Menu } from 'components/atoms/dropdown';
import { Caption01 } from 'components/styles';
import { FilterItem } from '../types';

const MenuItem = styled(Menu.Item)`
  justify-content: space-between;
`;
const Count = styled.span`
  ${Caption01};
  color: var(--gray-50);
`;

interface Props {
  labelPrefix: string;
  options: FilterItem[];
  selected: FilterItem;
  onChange: (value: FilterItem) => void;
  isManagerApproval: boolean;
}
export const TimesheetFilter: FC<Props> = ({
  labelPrefix,
  options,
  selected,
  onChange,
  isManagerApproval,
}) => {
  return (
    <Dropdown
      overlay={
        <Menu selectedKeys={[selected.value.toString()]}>
          <Menu.Header>{labelPrefix}</Menu.Header>
          {options.map((option) => (
            <MenuItem key={option.value} onClick={() => onChange(option)}>
              <span>{option.label}</span>
              {isManagerApproval && <Count>{option.count}</Count>}
            </MenuItem>
          ))}
        </Menu>
      }
    >
      <Button type="text" size="small" data-cy={labelPrefix}>
        <Space size={4}>
          <div>{labelPrefix}:</div>
          <strong>{selected.label}</strong>
        </Space>
      </Button>
    </Dropdown>
  );
};
